import React from "react";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import FlexibleDatePickerDates from "./FlexibleDatePickerDates";
import FlexibleDatePickerTable from "./FlexibleDatePickerTable";
import { format, parseISO } from "date-fns";

class FlexibleDatePicker extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      availability: this.props.availability || [],
      date: this.props.date || new Date(),
      loading: true,
      // selectedDates: this.populateSelectedDates(
      //   this.props.reservation_segments
      // ),
      selectedDates: {},
    };

    this.onBookNow = this.onBookNow.bind(this);
    this.onChangeAvailability = this.onChangeAvailability.bind(this);
    this.onChangeDate = this.onChangeDate.bind(this);
    this.onChangeLoading = this.onChangeLoading.bind(this);
    this.onSelectRoomTypeDate = this.onSelectRoomTypeDate.bind(this);
    this.onRemoveRoomTypeDate = this.onRemoveRoomTypeDate.bind(this);
    this.onAddDatesToAccommodations = this.onAddDatesToAccommodations.bind(this)
  }

  render() {
    // console.log("flex state", this.state)
    return (
      <div className="FlexibleDatePicker">
        <FlexibleDatePickerDates
          {...this.props}
          {...this.state}
          onChangeAvailability={this.onChangeAvailability}
          onChangeDate={this.onChangeDate}
          onChangeLoading={this.onChangeLoading}
        />
        <FlexibleDatePickerTable
          data={this.state.availability}
          currency={this.props.currency}
          selectedDates={this.state.selectedDates}
          reservationSegments={this.props.reservation_segments}
          onRemoveRoomTypeDate={this.onRemoveRoomTypeDate}
          onSelectRoomTypeDate={this.onSelectRoomTypeDate}
          onAddDatesToAccommodations={this.onAddDatesToAccommodations}
        />
        <LoadingSpinner size="small" show={this.state.loading} />
        {/* {this.renderBookNow()} */}
      </div>
    );
  }

  renderBookNow() {
    if (
    
      Object.keys(this.state.selectedDates).length ||
      this.props.reservation_segments.length
    ) {
      return (
        <div style={{ textAlign: "center" }}>
          {/* <button type="button" className="btn" onClick={this.onBookNow}> */}
          <button type="button" className="btn" onClick={this.onAddDatesToAccommodations}>
            {I18n.t("next")}
          </button>
        </div>
      );
    } else {
      return null;
    }
  }

  /*
   * Change handlers
   */

  onBookNow(e) {
    e.preventDefault();
    e.stopPropagation();

    this.setState({ loading: true });
    const room_types = {};
    Object.entries(this.state.selectedDates).map((entry) => {
      const { room_type, date } = entry[1];

      const dateObj = this.parseDate(date.date ? date.date : date);

      if (!room_types[room_type.id]) {
        room_types[room_type.id] = {};
      }
      if (Object.keys(room_types[room_type.id]).length === 0) {
        room_types[room_type.id].dates = [];
      }
      room_types[room_type.id].dates.push(dateObj);
    });


    this.props.onAddReservationSegments(room_types);
  }

  onAddDatesToAccommodations(e) {
    // console.log("add dates", e)
    e.preventDefault();
    e.stopPropagation();

    this.setState({ loading: true });
    const dates = [];
    Object.entries(this.state.selectedDates).map((entry) => {
      const { room_type, date } = entry[1];
      const dateObj = this.parseDate(date.date ? date.date : date);
      dates.push(dateObj);
      dates.push(room_type.id)

    });
    // console.log(dates)
    this.props.onGoToAccommodationsStep(dates)

  }

  onChangeAvailability(availability) {
    this.setState({ availability: availability });
  }

  onChangeDate(date) {
    this.setState({ date: new Date(date) });
  }

  onChangeLoading(loading) {
    this.setState({ loading: loading });
  }

  onRemoveRoomTypeDate(room_type, date) {
    const { selectedDates } = this.state;


    delete selectedDates[room_type.id + date.date];

    this.setState({
      selectedDates: selectedDates,
    });
  }
  
  onSelectRoomTypeDate(room_type, date) {
    // const { selectedDates } = this.state;
    const selectedDates = {};

    selectedDates[room_type.id + date.date] = {
      date: date,
      room_type: room_type,
    };

    this.setState({ selectedDates: selectedDates });
  }

  /**
   * Helper functions
   */
  parseDate(dateStr) {
    if (dateStr instanceof Date) {
      return dateStr;
    } else {
      return parseISO(dateStr);
    }
  }

  populateSelectedDates(segments) {

    const selectedDates = {};
    for (var i = 0, ilen = segments.length; i < ilen; i++) {
      const seg = segments[i];
      const { room_type } = seg;
      const start_date = this.parseDate(seg.check_in_date || seg.start_date);
      const end_date = this.parseDate(seg.check_out_date || seg.end_date);
      for (
        var d = new Date(start_date);
        d < end_date;
        d.setDate(d.getDate() + 1)
      ) {
        selectedDates[room_type.id + format(d, "u-MM-dd")] = {
          date: format(d, "u-MM-dd"),
          room_type: room_type,
        };
      }
    }
    return selectedDates;
  }
}

export default FlexibleDatePicker;
